<div class="sidemenu-body">
    <mat-sidenav-container *ngIf="isOpen" class="sidenav-container">
        <mat-sidenav
            [opened]="isOpen"
            mode="side"
            [fixedTopGap]="64"
            class="sidebar"
        >
            <div class="nav-list-center">
                <button class="custom-button" [routerLink]="'/home'">
                    <span class="button-content">
                        <mat-icon>home</mat-icon>
                        Inicio
                    </span>
                </button>
            </div>

            <mat-nav-list>
                <a
                    class="list"
                    mat-list-item
                    *ngFor="let route of mainRoutes"
                    [routerLink]="['/', route.path]"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }"
                >
                    <span class="button-content">
                        <mat-icon>{{ resolveIcon(route) }}</mat-icon>
                        {{ resolveText(route) }}
                    </span>
                </a>

                <mat-expansion-panel
                    class="submenu-panel"
                    *ngIf="moreRoutes.length"
                >
                    <mat-expansion-panel-header>
                        <span class="button-content">
                            <mat-icon>settings_24</mat-icon>
                            Más
                        </span>
                    </mat-expansion-panel-header>

                    <mat-nav-list dense>
                        <a
                            class="list"
                            mat-list-item
                            *ngFor="let route of moreRoutes"
                            [routerLink]="['/', route.path]"
                            routerLinkActive="active"
                            [routerLinkActiveOptions]="{ exact: true }"
                        >
                            <span class="button-content">
                                <mat-icon>{{ resolveIcon(route) }}</mat-icon>
                                {{ resolveText(route) }}
                            </span>
                        </a>

                        <a
                            class="list"
                            mat-list-item
                            *ngIf="colorsRoute"
                            [routerLink]="['/', colorsRoute.path]"
                            routerLinkActive="active"
                        >
                            <span class="button-content">
                                <mat-icon>{{
                                    resolveIcon(colorsRoute)
                                }}</mat-icon>
                                {{ resolveText(colorsRoute) }}
                            </span>
                        </a>
                    </mat-nav-list>
                </mat-expansion-panel>
            </mat-nav-list>
        </mat-sidenav>
    </mat-sidenav-container>
</div>
